<template>
    <div id="footer">
    <div class="footer clearfix">
        <div class="wrapper">
            <div class="col-sm-60 no-padding">
                <div class="logo-footer">
                    <div class="logo-footer">
                        <router-link to="/"><img src="/static/img/general/logo-white.png"></router-link>

                    </div>
                </div>
            </div>
            <div class="col-sm-60 no-padding clearfix">
                <div class="phone"><a :href="'tel:'+city.phone">{{city.phone}}</a></div>
            </div>
            <div class="col-xs-120 no-padding">
                <div class="line"></div>
            </div>
            <div class="col-md-20 col-sm-32 no-padding width-220">
                <div class="socials">
                    <a href="https://vk.com/public158802195" class="vk">
                        <img src="/static/img/general/vk.png">
                    </a>
                    <a href="https://www.facebook.com/groups/Vavtoservice/about/" class="fb">
                        <img src="/static/img/general/fb.png">
                    </a>
                    <a href="https://www.ok.ru/group/58784412139559" class="ok">
                        <img src="/static/img/general/ok.png">
                    </a>
                    <a href="https://twitter.com/V_Avtoservice" class="tw">
                        <img src="/static/img/general/tw.png">
                    </a>
                    <a href="https://www.youtube.com/channel/UCqDrBbmN5qdJUUM6rcHF6yA" class="youtube">
                        <img src="/static/img/general/youtube.png">
                    </a>
                </div>
                <div class="address">
                    <div class="location"><a :href="'tel:'+city.phone">{{city.phone}}</a></div>
                    <div class="email">{{city.email}}</div>
                </div>
                <div class="pay">
                </div>
            </div>

            <div class="col-md-20 col-sm-29 no-padding margin-left">
                <div class="car-owner">
                    <h4>Автовладельцам</h4>
                    <ul>
                        <li><router-link to="/car-marks/">Все марки авто</router-link></li>
                        <li><router-link to="/vot-pochemu-u-nas-deshevle/">Почему ремонт у нас дешевле</router-link></li>
                        <li><router-link to="/avtoservis/">Все сервисы</router-link></li>
                        <li><router-link to="/sovety-avtovladelcam/">Советы по ремонту авто</router-link></li>
                        <li><router-link to="/bonus/">Магазин подарков</router-link></li>
                    </ul>
                </div>
            </div>

            <div class="col-md-20 col-sm-29 no-padding margin-left">
                <div class="patrner-program">
                    <h4>Партнерские программы</h4>
                    <ul>
                        <li><router-link to="/connection/" class="bold">Подключить автосервис</router-link></li>
                        <li><router-link to="/postavshikam-zapchastej/">Поставщикам запчастей</router-link></li>
                        <li><router-link to="/avtomobil-nym-sajtam-i-blogeram/">Автомобильным сайтам</router-link></li>
                    </ul>
                </div>
                <div class="cooperation">
                    <h4>Сотрудничество</h4>
                    <ul>
                        <li><router-link to="/sale-franchise/">Открыть “В-Автосервис” в своём городе</router-link></li>
                        <li><router-link to="/sale-investment/">Инвестировать в открытие без участия в управлении</router-link></li>
                    </ul>
                </div>

            </div>
            <div class="col-md-20 col-sm-29 no-padding margin-left">
                <div class="info">
                    <h4>Информация</h4>
                    <ul>
                        <li><router-link to="/news/">Новости</router-link></li>
                        <li><router-link to="/rabota-s-yur-licami-i-avtoparkami/">Обслуживание автопарков</router-link></li>
                        <li><router-link to="/pol-zovatel-skoe-soglashenie/">Пользовательское соглашение</router-link></li>
                        <li><router-link to="/smi/" class="for-smi">Для СМИ</router-link></li>
                        <li><router-link to="/o-nas/" class="for-smi">Немного о нас</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer_b clearfix" >
        <div class="wrapper">
            <div class="footer_b-flags col-md-45 col-sm-40 no-padding">
                <a target="_blank" href="https://xn----8sbecarw9btief.xn--j1amh/">
                    <img src="/static/img/general/ukr.png">
                </a>
                <a target="_blank" href="https://xn----8sbecarw9btief.xn--90ais/">
                    <img src="/static/img/general/bel.png">
                </a>
                <a target="_blank" href="https://xn----8sbecarw9btief.xn--80ao21a/">
                    <img src="/static/img/general/kaz.png">
                </a>
                <a target="_blank" href="https://xn----8sbecarw9btief.xn--p1ai/">
                    <img src="/static/img/general/rus.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.uz/">
                    <img src="/static/img/general/uz.png">
                </a>
                <a target="_blank" href="https://easy-repair.lv/">
                    <img src="/static/img/general/lv.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.club/">
                    <img src="/static/img/general/ge.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.online/">
                    <img src="/static/img/general/az.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.kg/">
                    <img src="/static/img/general/kg.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.md/">
                    <img src="/static/img/general/md.png">
                </a>
                <a target="_blank" href="https://v-avtoservice.am/">
                    <img src="/static/img/general/am.png">
                </a>

            </div>
            <div class="col-sm-45 no-padding margin-left width-288">
                <div class="mobile">
                    <div class="mobile-app">
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=in_car_carecenter.rf">
                            <img class="mobile-app_img2" src="/static/img/general/google-play.png">
                        </a>
                        <a target="_blank" href="https://apps.apple.com/ru/app/id1469217999">
                            <img class="mobile-app_img2" src="/static/img/general/app-store.png">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-30 no-padding margin-left width-288">
                <div class="mobile-img">
                    <img class="img-iphone" src="/static/img/general/iphone.png">
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'footer-block',
  props: ['city', 'user', 'auth'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer.vue